import { connect } from 'react-redux';
import type { ActionCreator } from 'redux';
import { safeDifferenceInCalendarDays } from 'shared/util/datetime-fns';
import type { AccommodationState, OpenNumberRange, OverrideValues } from '@/interfaces';
import { actions } from '@/state/filterActions';
import { fetchHotels } from '@/ducks/searchResults/actions';
import { SelectedFilterItem } from '../../../../components/selectedFilterItem/SelectedFilterItem';
import { roundDownToClosestThousand } from './PriceFilter';
import { scrollToElementById } from '@/utils/scroll';
import { focusElementById } from '@/utils/focus';

interface StateProps {
    price?: OpenNumberRange;
    max: number;
}

interface DispatchProps {
    filterPrice: (price: OpenNumberRange) => void;
    triggerFetch: () => void;
}

export type SelectedPriceFilterProps = StateProps & DispatchProps & { openFilters: () => void };

export const SelectedPriceFilter = ({ price, max, filterPrice, triggerFetch, openFilters }: SelectedPriceFilterProps) => {
    if (price) {
        const displayValue = `${price[0]} kr - ${price[1] || `over ${max}`} kr`;
        const removeFilter = (): void => {
            filterPrice(undefined);
            triggerFetch();
        };
        const openFiltersAndScrollToId = () => {
            openFilters();
            scrollToElementById('PriceFilter');
            focusElementById('PriceFilter');
        };

        return <SelectedFilterItem value={`Pris: ${displayValue}`} removeFilter={removeFilter} openFilters={openFiltersAndScrollToId} />;
    }
    return null;
};

const mapStateToProps = (state: AccommodationState): StateProps => {
    const nightsSearched = safeDifferenceInCalendarDays(state.filters.checkInDate, state.filters.checkOutDate) ?? 1;
    return {
        price: state.filters.price,
        max: roundDownToClosestThousand(state.searchResults.highestTotalRate ?? 2000 * nightsSearched),
    };
};

const mapDispatchToProps: OverrideValues<DispatchProps, ActionCreator<unknown>> = {
    filterPrice: actions.filterPrice,
    triggerFetch: fetchHotels,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectedPriceFilter);
